export class Unauthenticated extends Error {
  constructor(message = 'unauthenticated') {
    super(message)

    this.name = 'Unauthenticated'
  }
}
